<p-toast></p-toast>

<div class="grid">
    <div class="col-12">
        <div class="card conversation-shell">
            <div class="conversation-topbar flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
                <div class="page-heading">
                    <div class="flex align-items-center gap-2 mb-1">
                        <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="goBack()"></button>
                        <h5 class="m-0">{{ conversation ? ('Conversación con ' + conversationHeadingName) : 'Conversación' }}</h5>
                    </div>
                    <small class="text-600">Leé el chat, respondé abajo y dejá la gestión al costado.</small>
                </div>
                <button pButton type="button" icon="pi pi-refresh" label="Recargar" class="p-button-outlined p-button-sm" (click)="refreshConversation()"></button>
            </div>

            <div *ngIf="loading" class="flex justify-content-center py-6">
                <p-progressSpinner></p-progressSpinner>
            </div>

            <ng-container *ngIf="!loading && conversation">
                <div class="conversation-hero mb-4">
                    <div class="hero-content">
                        <div class="hero-identity">
                            <div class="hero-title-row">
                                <div class="hero-title">{{ conversationHeadingName }}</div>
                                <span class="hero-meta-chip">ID {{ conversation.id }}</span>
                            </div>
                            <div class="hero-phone">{{ conversation.customer_phone_normalized || conversation.customer_phone }}</div>
                            <div class="hero-identity-meta">
                                <span *ngIf="conversation.contact_name" class="hero-meta-chip hero-meta-chip-success">Contacto vinculado</span>
                                <button
                                    *ngIf="showCreateContactAction"
                                    pButton
                                    type="button"
                                    icon="pi pi-user-plus"
                                    label="Crear contacto"
                                    class="p-button-text p-button-sm p-button-success hero-create-contact-button"
                                    pTooltip="Crear contacto"
                                    (click)="createContactFromConversation()">
                                </button>
                            </div>
                        </div>

                        <div class="hero-status">
                            <div class="hero-status-row">
                                <div class="hero-status-chips">
                                    <p-tag
                                        [severity]="getStatusSeverity(conversation)"
                                        [value]="getStatusLabel(conversation)"
                                        styleClass="hero-status-tag">
                                    </p-tag>
                                    <p-badge
                                        [value]="conversation.unread_count || 0"
                                        [severity]="(conversation.unread_count || 0) > 0 ? 'danger' : 'info'"
                                        styleClass="hero-unread-badge">
                                    </p-badge>
                                </div>
                                <small *ngIf="getStatusDetail(conversation)" class="text-600 hero-status-detail">{{ getStatusDetail(conversation) }}</small>
                                <small class="text-500 hero-activity">Última actividad: {{ conversation.last_message_at | date: 'dd/MM/yyyy HH:mm' }}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid conversation-layout">
                    <div class="col-12 xl:col-9 conversation-main-column">
                        <app-whatsapp-conversation-timeline
                            [conversation]="conversation"
                            [messages]="conversationDetail?.messages || []"
                            [events]="conversationDetail?.events || []"
                            [pasosFlujo]="flujoRegistro"
                            [loadingPasosFlujo]="loadingFlujoRegistro">
                        </app-whatsapp-conversation-timeline>

                        <app-whatsapp-conversation-actions
                            variant="composer"
                            [conversation]="conversation"
                            [assignableUsers]="assignableUsers"
                            [loadingUsers]="loadingUsers"
                            [availableReplyTemplates]="availableReplyTemplates"
                            [loadingTemplates]="loadingTemplates"
                            (updated)="refreshConversation()">
                        </app-whatsapp-conversation-actions>
                    </div>

                    <div class="col-12 xl:col-3 conversation-sidebar-column">
                        <div class="conversation-sidebar">
                            <app-whatsapp-conversation-actions
                                variant="management"
                                [conversation]="conversation"
                                [assignableUsers]="assignableUsers"
                                [loadingUsers]="loadingUsers"
                                [availableReplyTemplates]="availableReplyTemplates"
                                [messages]="conversationDetail?.messages || []"
                                [loadingTemplates]="loadingTemplates"
                                (updated)="refreshConversation()">
                            </app-whatsapp-conversation-actions>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading && !conversation">
                <div class="py-6 text-center text-600">
                    No se pudo cargar la conversación solicitada.
                </div>
            </ng-container>
        </div>
    </div>
</div>
